module.exports = __webpack_public_path__ + "img/eoy-giving-donate-3.6a404087.jpg";